<template>
  <div>
    <!-- HEADER
      ================================================== -->
    <section class="section section_header section_header__menu">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <!-- Heading -->
            <h1 class="section__heading section_header__heading text-center">
              Mittagskarte
            </h1>
            <div class="breadcrumb">
              <span class="active">
                Dieser Menüplan ist gültig von Montag - Freitag
              </span>
            </div>
          </div>
        </div>
        <!-- .row -->
      </div>
      <!-- .container -->
      <div class="section_header__bg menu_bg"></div>
    </section>
    <!-- section menu -->
    <section class="section_menu" id="section_menu">
      <div class="container">
        <div
          class="row menu__category"
          v-for="(dishCategory, index) in dishes"
          :key="index"
        >
          <span class="section_title">{{ dishCategory.title }}</span>
          <div class="row menu__text-grid">
            <div
              class="col-sm-6 menu__item"
              v-for="(entry, index) in dishCategory.entries"
              :key="index"
            >
              <h3>
                {{ entry.no }} {{ entry.title }}
                <span class="price">{{ entry.price.toFixed(2) }} €</span>
              </h3>
              <!--
              <p class="dish_ingredients">
                eggs / bacon / oil / beans / tomato
              </p>
              -->
              <p class="dish_info" v-if="entry.description">
                {{ entry.description }}
              </p>
              <p class="dish_info" v-else>
                <span class="empty">-/-</span>
              </p>
            </div>
          </div>
          <div class="row dishcategory_info" v-if="dishCategory.info">
            {{ dishCategory.info }}
          </div>
          <!-- .row -->
        </div>
      </div>
      <!-- .container -->
    </section>
  </div>
</template>

<script>
import MenuData from "@/data/menu";
export default {
  name: "Mittagskarte",
  metaInfo: {
    title: "Mittagskarte - Restaurant Dafni Aurich"
  },
  data() {
    return {
      dishes: MenuData.lunchDishes
    };
  }
};
</script>

<style lang="scss">
.row .menu__text-grid {
  margin: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.section_menu .menu__text-grid .menu__item {
  padding: 10px 10px;
}

.section_menu .menu__text-grid .menu__item > h3 {
  position: relative;
  padding-right: 70px;

  & .price {
    position: absolute;
    right: 8px;
    bottom: 5px;
  }
}

@media (max-width: 991px) {
  .section_menu .menu__text-grid .menu__item .dish_info {
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media screen and (max-width: 375px) {
  .menu__category .section_title {
    padding: 0 40px;
  }
}

.section_menu .menu__category .section_title {
  display: block;
  text-align: center;
  font-size: 27px;
  &:before {
    content: "";
  }
}

.dish_info .empty {
  visibility: hidden;
}

.menu__category .menu__item:nth-child(odd) {
  clear: both;
}

@media screen and (max-width: 767px) {
  .section_menu .menu__category .section_title {
    font-size: 25px;
  }
}
</style>
